export const boxShadow = {
  statement: "rgb(0 0 0 / 35%) 0px .3125rem 0.9375rem",
  question: "rgb(67 71 85 / 27%) 0px 0px 0.25em, rgb(90 125 188 / 5%) 0px 0.25rem 1rem",
  option: "rgb(60 64 67 / 30%) 0px 0.0625rem 0.125rem 0px, rgb(60 64 67 / 15%) 0px 0.0625rem 0.1875rem 0.0625rem",
};
